<section>
  <div class="cert__tab-header">
    <div>
      <p class="cert__subheader-subtle">
        {{ "Cert.PageDescription2" | translate }}
        <a href="https://wiki.surfnet.nl/display/SURFcert/DDoS-bescherming" target="_blank" rel="noopener noreferrer">
          https://wiki.surfnet.nl/display/SURFcert/DDoS-bescherming
          <i class="external-link"></i>
        </a>
      </p>
    </div>
  </div>
  <cert-mitigation></cert-mitigation>
  <cert-security></cert-security>
  <cert-ddos-chart [happyState]="true"></cert-ddos-chart>
</section>
